import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import GasSupply from './gas-supply';
import GasSupplyDetail from './gas-supply-detail';
import GasSupplyUpdate from './gas-supply-update';
import GasSupplyDeleteDialog from './gas-supply-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/scheduling/:schedulingId/new`} component={GasSupplyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/scheduling/:schedulingId/:id/edit/`} component={GasSupplyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={GasSupplyDetail} />
      <ErrorBoundaryRoute path={`${match.url}/scheduling/:schedulingId`} component={GasSupply} />
      <ErrorBoundaryRoute path={match.url} component={GasSupply} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/scheduling/:schedulingId/:id/delete`} component={GasSupplyDeleteDialog} />
  </>
);

export default Routes;
